module.exports = __webpack_public_path__ + "img/logo-2.47515a91.png";